import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Card } from '@widgets/shared/styles/card';
import { Content, Copy, Header, } from './styles';
function MiscCard(props) {
    const { backgroundImage, Description, SubDescription, displayPrice, handleClick, } = props;
    return (_jsx(Card, { backgroundImage: backgroundImage, children: _jsxs(Content, { children: [_jsx(Header, { children: Description }), _jsx("span", { className: "tag tag--aero tag--heading", children: displayPrice }), _jsx(Copy, { children: SubDescription }), _jsx("button", { type: "button", className: "btn btn--primary btn--full", onClick: () => handleClick(props), children: "Add to basket" })] }) }));
}
export default MiscCard;
